import type { ReactNode } from 'react';
import { styled } from 'styled-components';

interface Props {
  children: ReactNode;
}

const Block = styled.main`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  /* 既定の align-items:stretch だと、子カードがスクロール領域の高さに引き伸ばされて頭打ちになり、
     中身だけが下にはみ出す。flex-start で中身ぶんの自然な高さに収める。 */
  align-items: flex-start;
  background: #f0f2f5;
  padding: 24px;
  overflow-y: auto;
`;

export const ContentBlock = ({ children }: Props) => {
  return <Block>{children}</Block>;
};
